import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StarRateIcon from '@mui/icons-material/StarRate';
import { useTranslation } from 'react-i18next';
import { Chip, createTheme, ThemeProvider, Skeleton } from '@mui/material';
import { getSkills, updateSkillsItems } from '../../../../actions/cv';
import TitledSection from '../../../common/TitledSection/TitledSection';
import classes from './scss/skills.module.scss';
import AddEditFormModal from '../../../common/ModalWindows/AddEditFormModal';
import ActionsButton from '../../../common/buttons/ActionsButton/ActionsButton';
import colors from '../../../../scss/colors';

function Skills() {
  const dispatch = useDispatch();
  const skillsItems = useSelector((state) => state.cv?.skills?.response);
  const skillsPending = useSelector((state) => state.cv?.skills?.pendingFlag);
  const skillsError = useSelector((state) => state.cv?.skills?.error);
  const { t } = useTranslation();
  const userId = localStorage.getItem('UserId');

  const [openAddWindow, setAddWindow] = useState(false);

  useEffect(() => {
    dispatch(getSkills(userId));
  }, []);

  const updateSkills = async (data) => {
    dispatch(updateSkillsItems(userId, data.skills));
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: colors.PRIMARY_BLUE
      }
    },
    color: colors.WHITE
  });

  useEffect(() => {
    if (!skillsPending && !skillsError) setAddWindow(false);
  }, [skillsPending, skillsError]);

  return (
    <TitledSection
      title={t('profile.builder.details.skills')}
      actions={<ActionsButton activityName="edit" clickHandler={() => setAddWindow(true)} />}
    >
      {openAddWindow && (
        <AddEditFormModal
          key={skillsItems}
          open
          closeHandler={() => setAddWindow(false)}
          editeMode
          block="skills"
          initData={skillsItems}
          confirmHandler={updateSkills}
          pending={skillsPending}
          error={skillsError}
        />
      )}
      <div className={classes.skillsList}>
        {skillsItems ? (
          skillsItems?.map((item) => (
            <ThemeProvider key={item.SkillName} theme={theme}>
              <Chip
                className={classes.chip}
                label={item.SkillName}
                deleteIcon={item.TopSkill && <StarRateIcon fontSize="small" />}
                color="primary"
                variant={item.TopSkill ? 'filled' : 'outlined'}
                onDelete={item.TopSkill}
                sx={{ color: item.TopSkill && colors.WHITE, fontFamily: 'Gotham-Book' }}
              />
            </ThemeProvider>
          ))
        ) : (
          <Skeleton animation="wave" width="100%" />
        )}
      </div>
    </TitledSection>
  );
}

export default Skills;
